module.exports = __webpack_public_path__ + "why3.webp?63c1f165fda4b98d261c02e9e1eaa7de";